/**
 * Formata um CNPJ (14 dígitos) para o padrão: 00.000.000/0000-00
 */
export const formatarCNPJ = (cnpj: string): string => {
  const apenasNumeros = cnpj.replace(/\D/g, '');

  if (apenasNumeros.length !== 14) {
    return cnpj; // Retorna o original se não tiver 14 dígitos
  }

  return apenasNumeros
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

/**
 * Formata um CPF (11 dígitos) para o padrão: 000.000.000-00
 */
export const formatarCPF = (cpf: string): string => {
  const apenasNumeros = cpf.replace(/\D/g, '');

  if (apenasNumeros.length !== 11) {
    return cpf; // Retorna o original se não tiver 11 dígitos
  }

  return apenasNumeros
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/**
 * Formata telefone para os padrões:
 * - 8 ou 9 dígitos: (00) 0000-0000
 * - 10 ou 11 dígitos: (00) 00000-0000
 */
export const formatarTelefone = (telefone: string): string => {
  const apenasNumeros = telefone.replace(/\D/g, '');

  if (apenasNumeros.length === 8) {
    return apenasNumeros.replace(/(\d{4})(\d{4})/, '$1-$2');
  }

  if (apenasNumeros.length === 9) {
    return apenasNumeros.replace(/(\d{5})(\d{4})/, '$1-$2');
  }

  if (apenasNumeros.length === 10) {
    return apenasNumeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  if (apenasNumeros.length === 11) {
    return apenasNumeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  return telefone; // Retorna o original se não corresponder aos padrões
};

/**
 * Formata CEP (8 dígitos) para o padrão: 00000-000
 */
export const formatarCEP = (cep: string): string => {
  const apenasNumeros = cep.replace(/\D/g, '');

  if (apenasNumeros.length !== 8) {
    return cep; // Retorna o original se não tiver 8 dígitos
  }

  return apenasNumeros.replace(/^(\d{5})(\d{3})$/, '$1-$2');
};

/**
 * Remove toda a formatação e retorna apenas os números
 */
export const removerFormatacao = (valor: string): string => {
  return valor.replace(/\D/g, '');
};

/**
 * Função genérica que detecta automaticamente o tipo e formata
 */
export const formatarDocumento = (valor: string): string => {
  const apenasNumeros = removerFormatacao(valor);

  switch (apenasNumeros.length) {
    case 8: // CEP
      return formatarCEP(valor);
    case 11: // CPF
      return formatarCPF(valor);
    case 14: // CNPJ
      return formatarCNPJ(valor);
    case 10:
      return formatarTelefone(valor);
    default:
      return valor;
  }
};

// Exemplos de uso:
/*
console.log(formatarCNPJ('12345678000195')); // 12.345.678/0001-95
console.log(formatarCPF('12345678901')); // 123.456.789-01
console.log(formatarTelefone('1199999999')); // (11) 99999-9999
console.log(formatarCEP('12345678')); // 12345-678
console.log(formatarDocumento('12345678901')); // 123.456.789-01
*/
